import enLocal from 'vant/lib/locale/lang/en-US'
import faJame from './languageJame/fa'
import faGaea from './languageGaea/fa'
const fa = {
  300000: '新年送礼',
  300001: '2022新年送礼',
  300002: 'SuperEx和你一起过新年',
  300003: '尊敬的SuperEx用户：<br>为庆祝SuperEx在新年之际盛大上线,<br>平台将随机空投送出价值1,000,000 USDT新年大礼包。 <br>具体活动如下：',
  300004: '活动时间<br>加拿大时间：2022年01月01日00：00-02月15日23：59',
  300005: '活动一：分享海报获空投',
  300006: '分享活动海报至＞1000人的telegram加密货币群组，并附言“百万豪礼大派送，SuperEx和你一起过新年！或分享活动海报至个人Tiwwer，置顶并附言“百万豪礼大派送，SuperEx和你一起过新年！ ”上传截图给客服，将有机会获得5 ET（价值5 USDT）。',
  300007: '活动二：邀新获VIP',
  300008: '获得期间，用户通过邀请好友新注册并成功入金≥100 USDT即为有效邀请人数。成功邀请人数越多，所获VIP等级越高。有效期（30天）',
  300009: '活动三：新用户充值送',
  300010: '活动期间，新注册用户净充值金额达到一下区间并完成一笔交易，即可获得ET奖励。 （净充值金额在活动结束前以USDT结算）活动期间，新注册用户净充值金额达到一下区间并完成一笔交易，即可获得ET奖励。 （净充值金额在活动结束前以USDT结算）',
  300011: '注意事项：',
  300012: '1.每位参与用户只能获得一次奖励 <br>2.所有参与用户默认遵守SuperEx服务条款，如发现违规将立即停止其活动资格 <br>3.SuperEx有权在不提早通知用户的情况下修改本次活动的条款 <br>4.SuperEx将取消不合规用户活动参与资格并停用相关SuperEx账户使用 <br>5.SuperEx保留本次活动最终解释权',
  300013: '立即分享',
  300014: 'SuperEx团队',
  300015: '2022年01月01日',
  300016: '更多信息关注SuperEx官网：SuperEx.com',
  300017: '净充值金额（{coin}）',
  300018: '奖励金（{coin}）',
  300019: '180天',
  300020: '净充值=总入金金额-总出金金额',
  300021: 'ET持仓数量',
  300022: 'Maker/Taker',
  300023: '有效邀请人数',
  300024: '赠送有效期',
  300025: '活动获取条件',
  300026: '注：所有赠送的VIP等级均无需ET持仓要求。 ',
  300027: 'کپی موفقیت آمیز بود',
  300028: 'کپی نشد',

  300029: ' دانلود SuperEx APP',
  300030: 'در هر زمان و هر مکان صرافی کنید',
  300031: 'حساب SuperEx ایجاد کنید',
  300032: '若您已有SuperEx账户，请先登录',
  300033: 'ایمیل',
  300034: 'موبایل',
  300035: 'شماره موبایل',
  300036: 'رمز عبور،',
  300037: 'شناسه ارجاع (اختیاری)',
  300038: 'من خوانده ام و موافقم',
  300039: 'شرایط خدمات SuperEx',
  300040: 'من بالای 18 سال سن دارم و با شرایط SuperEx موافقم',
  300041: 'ثبت نام',
  300042: 'تایید امنیتی',
  300043: 'کد منطقه را انتخاب کنید',
  300044: 'جست و جو',
  300045: 'لطفا شماره موبایل خود را وارد نمایید',
  300046: 'لطفا شماره موبایل درست وارد منید',
  300047: 'لطفاایمیل خود را وارد نمایید',
  300048: 'لطفا ایمیل معتبر خود را وارد نمایید',
  300049: 'رمزعبور خود را وارد نمایید',
  300050: 'حداقل 8 کاراکتر، از جمله حروف بزرگ و اعداد',
  300051: 'کد تایید ایمیل',
  300052: 'کد تایید تلفن',
  300053: 'Google/Microsoft Auth',
  300054: 'گوگل/مایکروسافت',
  300055: 'برای امنیت حساب خود، لطفاً عملیات تأیید زیر را تکمیل کنید',
  300056: 'ارسال',
  300057: 'کد 6 رقمی به آدرس {phone} ارسال می شود.',
  300058: 'کد به ایمیل {email} ارسال می شود.',
  300059:'لطفاً کد تأیید 6 رقمی سوپراکس/گوگل/مایکروسافت را وارد کنید',
  300060: 'کد تایید 6 رقمی را وارد کنید',
  300061: 'کد ارسال شد',
  300062: '{timeout}s',
  300063: 'زبان',
  300064: '审核中',
  300065: 'حروف انگلیسی یا علائم نگارشی رایج را وارد کنید',


  300066: 'مرکز وظیفه',
  300067: 'نبرد رتبه بندی تخفیف',
  300068: 'تا<em class="bold normal" style="font-size: 1.2rem;color: #FFC72B;">1BTC</em> برنده شوید!',
  300069: 'دعوت کردن',
  300070: 'تابلوی امتیازات',
  300071: 'قوانین باز کردن قفل',
  300072: 'ET بیشتری دریافت کنید',
  300073: 'نبرد رتبه بندی تخفیف. حداکثر 1 BTC در انتظار شماست!',
  300074: 'برای باز کردن قفل ET، تراکنش را کامل کنید',
  300075: 'تمام وظایف بالا را برای قرار گرفتن در لیست سفید انجام دهید و SuperEx به طور تصادفی مقدار زیادی از توکن های ET را هر از گاهی به کاربران لیست سفید ارسال می کند.',
  300076: 'رتبه بندی روزانه',
  300077: 'رتبه بندی کل',
  300078: 'شرایط استفاده از خدمات',
  300079: 'جوایز من',

  300080: 'مقدار قفل',
  300081: 'مقدار باز کردن قفل',
  300082: 'مقدار باز کردن قفل = کارمزد معامله * دشواری باز کردن قفل / قیمت ET',
  300083: 'به صرافی بروید',
  300084: 'رتبه بندی',
  300085: 'حساب',
  300086: 'کمیسیون',
  300087: 'توجه: رتبه بندی روزانه تا ساعت 0:00 روز (UTC-4) محاسبه می شود و جوایز روز بعد صادر می شود. ممکن است خطاهایی در داده ها فقط برای مرجع وجود داشته باشد.',
  300088: 'توجه: جوایز ظرف 3 روز کاری پس از پایان رویداد صادر می شود و ممکن است داده ها فقط برای مرجع دارای خطا باشند.',
  300089: 'بیشتر',

  300090: 'بستن',
  300091: 'شما در حال حاضر یک کاربر در لیست سفید هستید!',
  300092: 'حساب {type} خود را وارد کنید',
  300093: 'مرحله نهایی',
  300094: 'ما را در توییتر دنبال کنید',
  300095: 'به گروه رسمی تلگرام ما بپیوندید',
  300096: 'شروع سپرده گذاری',
  300097: 'شروع معامله اسپات',
  300098: 'بلافاصله معامله فیوچرز را وارد کنید',
  300099: 'یک دوست را برای ثبت نام معرفی کنید',

  300100: 'یک دوست را برای تجارت دعوت کنید',
  300101: 'به یک دوست برای تجارت بیشتر توصیه کنید',
  300102: 'سپرده',
  300103: 'دنبال کردن',
  300104: 'مطالبه',
  300105: 'جمع آوری شده (بارها)',
  300106: 'هنوز باز نشده',
  300107: 'ملحق شدن',
  300108: 'هیچ رکوردی یافت نشد',
  300109: 'تکمیل شد',
  300110: 'دوستان را دعوت کنید و SCS بیشتری دریافت کنید',
  300111: 'لغو کنید',
  300112: 'ارسال',
  300113: 'دوباره ارسال نکنید',
  300114: 'در حال حاضر هیچ وظیفه ای وجود ندارد',
  300115: 'منتظر کارهای بیشتر باشید',
  300116: 'منتظر رویدادهای بیشتر باشید!',
  300117: 'لطفا حساب کاربری خود را وارد کنید',
  300118: 'لطفا حساب خود را وارد کنید',
  300119: 'تکذیب کرد',
  300120: 'ثبت نام فوری برای SuperEx',
  300121: 'ثبت نام',
  300122: 'منقضی شده',
  300123: 'کاغذ سفید',

  300124: 'پاداش mystery box',
  300125: 'تا 1000 USDT پاداش در جعبه رمز و راز کریپتو با  <em class="normal bold" style="color: #FFC72B">100%</em> نرخ برنده دریافت کنید ',
  300126: 'قوانین',

  300127: 'جعبه Mystery Box را باز کنید',
  300128: 'تعداد قرعه کشی',
  300129: 'باقی مانده (مال من)',
  300130: ' باز شده (مجموع USDT)',
  300131: 'پاداش',
  300132: 'چگونه شرکت کنیم؟',
  300133: 'لینک دعوت خود را به اشتراک بگذارید',
  300134: 'وظایف را کامل کنید',
  300135: 'دوستان خود را برای ثبت نام و تکمیل وظایف معاملاتی دعوت کنید',
  300136: 'جعبه mystery box را دریافت کنید',

  300137: 'وظایف را کامل کنید و Mystery Box را دریافت کنید',
  300138: 'این رویداد به پایان رسیده است، لطفا منتظر رویداد بعدی باشید!',
  300139: 'این رویداد هنوز شروع نشده است، پس با ما همراه باشید!',
  300140: 'قوانین رویداد',
  300141: 'باشه',
  300142: 'زمان',
  300143: '',
  300144: '',
  300145: 'دوستان خود را دعوت کنید',
  300146: '<em class="normal" style="color: #FFC72B">فانوس</em> های جک را روشن کنید و از هالووین لذت ببرید',
  300147: 'برای <em class="normal" style="color: #FFC72B">{num}</em> روز متوالی وارد شوید و شانس برنده شدن جایزه <em class="normal" style="color: #FFC72B">{amount} ET</em> را داشته باشید',
  300148: 'لیست برندگان',
  300149: 'ورود روزانه',

  300150: ' شما {num} روز وارد شده اید',
  300151: 'قرعه کشی جایزه',
  300152: 'وارد شدن',
  300153: 'ورود',
  300154: '',
  300155: '',
  300156: 'ورود',
  300157: 'کوپن اعتباری هزینه قرارداد دریافت کرد!',
  300158: 'ارتقاء VIP با موفقیت انجام شد!',
  300159: 'شانس برنده شدن در قرعه کشی را داشته باشید!',

  300160: 'کوپن هزینه قرارداد',
  300161: 'ارتقاء VIP',
  300162: '',
  300163: 'شما <em class="normal" style="color: #FFC72B">{num}</em> فرصت هایی برای امضای مجدد دارید',
  300164: 'فرصتی برای ورود به سیستم داشته باشید',
  300165: 'می تواند دوباره به سیستم وارد شود',
  300166: 'نکات',
  300167: 'دوباره با موفقیت امضا شد',
  300168: 'شما هنوز تعداد ورود به سیستم را ندارید، می‌توانید در همان روز برای یک سپرده خالص ≥{num} {symbol}، دوباره وارد سیستم شوید.',
  300169: 'ورود',

  300170: 'به حد مجاز ورود مجدد رسیدید',
  300171: 'لیست برنده کاربرانی که به مدت 7 روز متوالی وارد سیستم شده اند',
  300172: 'برای دریافت جوایز زیر پیوسته وارد شوید',
  300173: 'دریافت شد',
  300174: '{num} روزها',
  300175: 'کوپن',
  300176: '. سطح VIP من',
  300177: 'در قرعه کشی شرکت کنید',
  300178: 'تبریک می گویم!',
  300179: 'ورود با موفقیت انجام شد',
  300180: '',
  300181: 'آکادمی',
  300182: 'اخبار',
  300183: 'داده‌ها',
  300184: 'فرا گرفتن',
  300185: 'نگاهی عمیق به رویدادهای مهم در صنعت کریپتو جهانی داشته باشید',
  300186: 'مروری سریع از آخرین رویدادهای صنعت کریپتو در سراسر جهان دریافت کنید',
  300187: 'همه چیز را در مورد بلاکچین، وب3 و ارز دیجیتال بیاموزید',
  300188: 'ادامه مطلب',
  300189: 'فیلم‌ها',
  300190: 'بارگذاری ',
  300191: 'همه بارگذاری شده است',
  300192: 'همه',
  300193: 'مسابقات شروع نشده است',
  300194: 'برنده جام جهانی را برای برنده شدن محدود <em class="normal" style="color:#DBFF00">پاداش</em> انتخاب کنید',
  300195: 'زمان رویداد',
  300196: 'نتیجه رای گیری',
  300197: 'مرحله گروهی',
  300198: '{num}گروه ',
  300199: 'استخر جایزه: {num} ',
  300200: 'زمان پیش بینی ',
  300201: 'مرحله حذفی',
  300202: 'رقابت',
  300203: 'مهلت رای دادن',
  300204: 'رای',
  300205: 'لطفا شماره پشتیبانی را وارد کنید',
  300206: 'حداقل تعداد شرط بندی: {num}ET',
  300207: 'زمان پیش بینی',
  300208: 'شرط بندی روی تیم ها',
  300209: 'رای',
  300210: 'مبلغ جایزه',
  300211: 'تیم های واجد شرایط',
  300212: 'روز',
  300213: 'ساعت',
  300214: 'دقیقه',
  300215: 'ثانیه',
  300216: 'بار',
  300217: 'رویداد هنوز شروع نشده است',
  300218: '1/4 نهایی',
  300219: 'تایید',
  300220: 'تعداد پشتیبانی',
  300221: 'تعادل ناکافی',
  300222: 'واریز',
  300223: 'پیش بینی موفقیت آمیز',
  300224: '1/8 نهایی',
  300225:'نیمه نهایی',
  300226:'فینالیست های سوم و چهارم',
  300227:'فینال',
  300228: 'پیروزی',
  300229: 'ضرر - زیان',
  300230: 'مجموع جایزه:{num} ET',
  300231: 'مشاهده مسابقات بیشتر',
  300232: 'سایر مسابقات',
  300233: 'ارز',
  300234: 'قیمت بازار',
  300235: 'تغییرات 24 ساعته',
  300236: 'راهنمای کاربر جدید',
  300237: 'از هم اکنون یادگیری صرافی ارز دیجیتال را شروع کنید',
  300238: 'حضور جهانی',
  300239: 'بدون مرز، عدم تمرکز جامعه و استقلال، تمرکززدایی تیم شکل نهایی توسعه SuperEx است.',

  300240: 'خطر امنیتی صفر',
  300241: 'SuperWallet غیرمتمرکز یکپارچه شده است و کلید خصوصی رمزگذاری شده و در دستگاه کاربر ذخیره می شود. تحت تأثیر امنیت کد، سیاست و عوامل دیگر قرار نمی گیرد',
  300242: 'بدون ثبت نام و KYC',
  300243: 'تراکنش های مجاز کیف پول، بدون ثبت، بدون KYC، تسویه تراکنش ها در زنجیره تکمیل می شود، قابل دستکاری نیست، ایمن و شفاف',
  300244: 'سیستم باز',
  300245: 'به کاربران اجازه دهید با Dapp یا قراردادهای هوشمند تعامل داشته باشند، با باز کردن SuperWallet، کاربران می توانند مجوز مشارکت در متا، دیفای و NFT را داشته باشند.',
  300246: 'صندوق فضایی',
  300247: 'صندوق فضایی برای اکتشاف انسان در فضا یا برای تأمین مالی مؤسسات یا افرادی که سهم قابل توجهی در اکتشاف انسان در فضا داشته اند استفاده می شود.',
  300248: 'یک صرافی امن و آسان برای استفاده',
  300249: 'برنامه تلفن همراه SuperEx را دانلود کنید تا بازار را زیر نظر داشته باشید و در هر لحظه که هستید، معاملات را انجام دهید.',

  300250: 'دانلودهای بیشتر',
  300251: 'هر معامله ای که انجام می دهید سوختی برای انسان ها برای پرواز به فضا است',
  300252: 'ثبت نام کنید',
  300253: 'iOS و Android<br>اسکن برای دانلود',
  300254: 'تاییدهویت',
  300255: 'تاییدهویت یک کد تایید 2 مرحله ای برای شما ایجاد می کند. با تأیید صحت 2 مرحله ای حساب سوپراکس خود را حتی بیشتر ایمن نگه دارید.',
  300256: 'بررسی SuperEx',
  300257: 'تایید هویت گوگل',
  300258: 'تایید هویت مایکروسافت',
  300259: 'دانلود مشتری (iPhone)',

  300260: 'دانلود مشتری (Android)',
  300261: 'امن ترین پلتفرم تجارت صرافی دیجیتال جهان!',
  300262: 'درباره ما',
  300263: 'مقررات',
  300264: 'حریم خصوصی',
  300265: 'اطلاعیه ها',
  300266: 'آکادمی',
  300267: 'مرکز مبتدیان',
  300268: 'تجارت Spot',
  300269: 'فیوچرز',

  300270: 'سوالات متداول',
  300271: 'خدمات',
  300272: 'کارمزدها',
  300273: 'قوانین',
  300274: 'برنامه لیست',
  300275: 'رفرال',
  300276: 'ارتباط با ما',
  300277: 'سوالات متداول',
  300278: 'ارسال درخواست',
  300279: 'مخاطبین تجاری',

  300280: 'همکاری نهادی',
  300281: 'بیشتر',
  300282: 'مجدد خوش آمدید!',
  300283: 'رمز عبور خود را فراموش کرده اید؟',
  300284: 'حساب کاربری ندارید؟?',
  300285: 'برای بازیابی رمز عبور به برنامه یا رایانه بروید',
  300286: 'باشه',

  300287: 'تایید ',
  300288: 'اعلام می شود',
  300289: 'دریافت شود',

  300290: 'قبلاً ملحق شده اید',
  300291: 'قبلاً بازپرداخت شده است',
  300292: 'قوانین خرید',
  300293: "خرید <span style='color: #ffc72b;'>کالا</span>",
  300294: 'انتخاب و خرید کنید',
  300295: 'در انتظار نتایج',
  300296: 'مورد را دریافت کنید',
  300297: 'واریز',
  300298: 'نتیجه خرید',
  300299: 'فهرست اشیا',
  300300: 'هزینه مشارکت یکباره',
  300301: '{num} نسخه فروخته شده است. کالا پس از رسیدن به {price} {currency} فروخته خواهد شد.',
  300302: 'همین الان بپیوندید',
  300303: 'دوباره بپیوندید',
  300304: 'تعداد کپی ها را برای خرید انتخاب کنید',
  300305: "1 نسخه به <span style='color: #fa4d56;'>{minPrice} {currency}</span> نیاز دارد و یک مورد را می توان حداکثر<span style='color: #fa4d56;'>{maxBuyCount} کپی</span> خریداری کرد.",
  300306: 'کپی',
  300307: 'شما {num} {currency} دارید، هر چه تعداد نسخه های بیشتری بخرید شانس برنده شدن بیشتر می شود!',
  300308: 'خرید',
  300309: 'دفعه بعد',
  // 300309: '余额充值',
  300310: 'تبریک می گویم!',
  300311: 'مطالبه',
  300312: 'دوباره امتحان کنید!',
  300313: 'واریز ارز دیجیتال یا P2P را در برنامه تکمیل کنید.',
  // 300314: '我知道了',
  300315: 'با خدمات مشتری در برنامه تماس بگیرید تا مورد را درخواست کنید.',
  // 300316: '我知道了',
  300317: 'ورود / ثبت نام',
  300318: 'هزینه {num} {currency}',
  300319: 'توضیحات مورد',
  300320: 'مشارکت من',
  300321: 'تاریخ',
  300322: 'اقلام شرکت کننده',
  300323: 'تعداد نسخه های خریداری شده',
  300324: 'مقدار بازپرداخت',
  300325: 'عمل',
  300326: 'مطالبه',
  300327: 'از قبل حساب کاربری دارید؟',
  300328: 'ورود',
  300329: 'رمز شناسایی',
  300330: 'فقط نتایج هفت روز گذشته نشان داده می شوند',
  300331:'تاییدهویت',
  300332:' دانلود',
  300333:'با 1USDT می تواند 1 بیت کوین بخرد',
  300334:"قیمت خرید ",
  300335:"نتایج قبلی",
  // 300336:"期次",
  300337:"مشاهده قوانین",
  300338:"موضوع: [فاز {num}]",
  300339:"فرآیند خرید",
  300340:"کاربران با موفقیت خریداری شدند",
  300341:"زمان اعلام",
  300342:"اشتراک گذاری",
  300343:"شماره [{num}]",
  300345:" دانلود",
  300346:"شادی خود را به اشتراک بگذارید",
  300347:"اسکن کد برای عضویت",
  300348:"مورد را دریافت کنید",
  300349:"توجه: اقلام ارز دیجیتال ظرف 48 ساعت به حساب شما ارسال می شود.",
  300350:"برای مطالبه سایر موارد با خدمات مشتری تماس بگیرید",
  300351:"به مشاهده بروید",
  300352:"اکنون ثبت نام کنید",
  300353:"ثبت شده است",
  300354:'ثبت نام بسته شده است',
  300355:'ثبت نام موفقیت آمیز بود',
  300356:'برنامه را باز کنید',
  300357:'به user0} برای کسب {shop} تبریک می‌گوییم!',
  300358:'مرکز رویدادها',
  300359:'درحال پیش رفتن',
  300360:'به زودی شروع می شود',
  300361:'به پایان رسید',
  300362:'هم اکنون عضو شوید',
  300363: 'به پایان رسید',
  300364: 'برندگان',
  300365: 'برندگان به‌زودی اعلام خواهند شد',


  310000:'مرور کلی پاداش',
  310001:'استراق سمع کردن',
  300366: 'ارز',
  300367: 'فروش',
  200368: 'پرداخت می کند',
  300369: 'دریافت',
  300370: 'گرفتن',
  300371: 'محدودیت تک تراکنش:',
  300372: 'روش پرداخت',
  300373: 'روش پرداخت',
  300374: 'ارائه دهنده پرداخت',
  300375: 'جزئیات سفارش',
  300376: 'مبلغ (شامل کارمزد تراکنش)',
  300377: 'زمان رسیدن',
  300378: 'سلب مسئولیت',
  300379: 'من سلب مسئولیت را خوانده ام و با آن موافقم',
  300380: "شما سوپراکس را ترک خواهید کرد و به <span>{name}</span> می‌روید، یک موسسه مالی دارای مجوز که قابلیت‌های پرداخت کارت را به عنوان شخص ثالث ارائه می‌کند. هر اتفاق خطری که در طول استفاده رخ دهد توسط <span>{name}</span> متحمل می‌شود. لطفاً<span>{name}</span> را بخوانید و موافقت کنید.<a class= 'pointer'  href={server}>توافقنامه خدمات</a> قبل از استفاده از خدمات آناگر در مورد سپرده کارت اعتباری سؤالی دارید، لطفاً برای جزئیات بیشتر با <a class='pointer' href={Customer}>{name} خدمات مشتری</a> تماس بگیرید.",
  300381: 'چگونه در سوپراکس ارز دیجیتال بخریم؟',
  300382: 'نحوه فروش ارزهای دیجیتال در سوپراکس',
  300383: 'سفارش ارز دیجیتال خود را انجام دهید',
  300384: 'ارز فیات را که می خواهید با آن پرداخت کنید و کریپتویی را که می خواهید بخرید انتخاب کنید. مبلغی را که می خواهید خرج کنید وارد کنید.',
  300385: 'احرازهویت خود را تأیید کنید',
  300386: 'برای تکمیل پرداخت، تأیید احرازهویت را در سوپراکس و ارائه‌دهنده پرداخت کامل کنید.',
  300387: 'جزئیات سفارش خود را بررسی کنید',
  300388: 'سابقه واریز خود را برای مشاهده وضعیت سفارش خود بررسی کنید.',
  300389: 'سوالات متداول',
  300390: '1. از چه روش های پرداختی می توانم برای خرید ارز دیجیتال استفاده کنم؟',
  300391: 'سوپراکس در حال حاضر از VISA، Mastercard، Apple Pay، Google Pay و سایر روش های پرداخت پشتیبانی می کند. ارائه دهندگان خدمات شخص ثالث پشتیبانی شده عبارتند از Mercuryo و alchemypay.',
  300392: '2. کدام ارزهای رمزنگاری شده را می توانم خریداری کنم؟',
  300393: 'سوپراکس از ارزهای دیجیتال اصلی مانند BTC، ETH، USDT، LTC، USDC، XRP، BCH، CRV و TRX پشتیبانی می کند.',
  300394: '3. آیا سوپراکس بر کیفیت و قیمت ارائه دهندگان خدمات شخص ثالث پشتیبانی می شود؟',
  300395: 'سوپراکس تعدادی از ارائه دهندگان خدمات با شهرت، محبوبیت و امنیت صنعت قابل اعتماد را به دقت انتخاب کرده است تا به کاربران خدمات کارآمد ارائه دهد.',
  300396: '4. برای خرید ارز دیجیتال چه هزینه هایی باید پرداخت کنم؟',
  300397: 'شما هزینه ای را به ارائه دهنده خدمات شخص ثالث و هزینه انتقال زنجیره ای پرداخت می کنید. سوپراکس هیچ هزینه ای دریافت نمی کند.',
  300398: '5. پس از پرداخت چقدر طول می کشد تا ارز دیجیتال را دریافت کنید؟',
  300399: 'پس از تکمیل پرداخت شما در پلتفرم ارائه دهنده خدمات شخص ثالث، ارز دیجیتال شما در حدود 2 تا 10 دقیقه به حساب شما در سوپراکس واریز می شود.',
  300400: '6. اگر در فرآیند خرید با مشکل مواجه شوم چه می شود؟',
  300401: 'در صورت بروز هرگونه مشکل در فرآیند تراکنش با پشتیبانی مشتری تماس بگیرید. اگر پس از تکمیل پرداخت، ارز دیجیتال را دریافت نکرده‌اید، با ارائه‌دهنده خدمات شخص ثالث تماس بگیرید تا جزئیات سفارش را بررسی کنید (این روش معمولاً کارآمدترین روش است). به دلیل IP منطقه فعلی شما یا دلایل خاص سیاست، باید تأیید انسانی را انتخاب کنید.',
  300402: "دردسترس",
  300403: 'موجودی کافی وجود ندارد',
  300404: 'Please enter currency',
  300405: 'ارز فیات را وارد کنید',
  300406: 'شما تأیید هویت را تکمیل نکرده اید',
  300407: "برای امنیت حساب خود با سایر کاربران تجاری، لطفاً ابتدا تأیید هویت را تکمیل کنید",
  300408: 'تأیید شود',
  300409: 'تایید نشده',
  300410: 'واحد ارز را انتخاب کنید',
  300411: 'ارز فیات را انتخاب کنید',
  300412: 'All currencies',
  300413: 'تمام ارزهای فیات',
  300414: '≈{time} دقیقه',
  300415: 'تجارت P2P در حال حاضر برای کاربران مجاز کیف پول باز نیست، لطفاً از حساب سوپراکس خود برای ورود به سیستم و تجارت P2P استفاده کنید.',
  300416: 'https://support.superex.com/hc/en-001/articles/23084120565017',
  300417:'خرید کنید',
  300418: 'شماره سریال',
  300419: 'کارناوال هالووین سوپراکس',
  300420: 'برای لذت بردن از هدایا وارد شوید و برای برنده شدن جوایز معامله کنید!',
  300421:'نوع',
  300422:'جوایز ارزهای دیجیتال',
  300423:'',
  300424:'',

  400000:'اولین صرافی Web3 در جهان',
  400001:'برای ایجاد دنیای مالی به ما بپیوندید',
  400002: 'هر معامله ای که انجام می دهید سوختی برای انسان ها برای پرواز به فضا است',
  400003:'خلاصه هیجان انگیز سوپراکس',
  400004:'تعامل فعال و لبخندهای مشترک: داستان انلاین فعالیت ما',
  400005:'زبان و منطقه خود را انتخاب کنید',
  400006:'0 خطر',
  400007:'بدون احرازهویت',
  400008:'باز کردن',
  400009:'سرمایه',
  400010:'شبکه اصلی را جستجو کنید',
  400011:'تست نت را جستجو کنید',
  400012:'اسناد توسعه دهنده',
  400013:'بقیه',
  400014:'منطقه ET',
  400015:'',

  ...enLocal,
  ...faJame,
  ...faGaea
}
export default fa;



// WEBPACK FOOTER //
// ./src/i18n/langs/fa.js